import React from "react";
import styles from './Tag.module.scss';
import PropTypes from "prop-types";

const Tag = ({
  text,
  variant,
  rounded = false
}) => {
  return (
    <span className={`${styles.tag} ${styles[`tag-${variant}`] ?? ''} ${rounded ? styles.rounded : ''}`}>
      {text}
    </span>
  )
};

Tag.propTypes = {
  text: PropTypes.string.isRequired,
  variant: PropTypes.number.isRequired,
  rounded: PropTypes.bool
};

export default Tag;